import { render, staticRenderFns } from "./ProductVariationTab.vue?vue&type=template&id=3bbb044e&scoped=true"
import script from "./ProductVariationTab.vue?vue&type=script&lang=ts"
export * from "./ProductVariationTab.vue?vue&type=script&lang=ts"
import style0 from "./ProductVariationTab.vue?vue&type=style&index=0&id=3bbb044e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbb044e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bbb044e')) {
      api.createRecord('3bbb044e', component.options)
    } else {
      api.reload('3bbb044e', component.options)
    }
    module.hot.accept("./ProductVariationTab.vue?vue&type=template&id=3bbb044e&scoped=true", function () {
      api.rerender('3bbb044e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/products/components/ProductVariationTab.vue"
export default component.exports